module.exports = __webpack_public_path__ + "static/img/news.8d8f651.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/index/news.png
// module id = 1171
// module chunks = 18